import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { globalErrorResponse } from '../../../../store/notifications/actions';
import { apiChangeReserveReportSettings } from './apiChangeReserveReportSettings';

export const useChangeReserveReportSettings = () => {
    const dispatch = useDispatch();
    return useCallback(
        (message: string) => {
            apiChangeReserveReportSettings(message).catch(error => dispatch(globalErrorResponse(error)));
        },
        [dispatch]
    );
};
